import { render } from "./AppToggleSwitch.vue?vue&type=template&id=6ae1f05e&scoped=true"
import script from "./AppToggleSwitch.vue?vue&type=script&lang=js"
export * from "./AppToggleSwitch.vue?vue&type=script&lang=js"

import "./AppToggleSwitch.vue?vue&type=style&index=0&id=6ae1f05e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae1f05e"]])

export default __exports__